var r=function(r){return null===r?0:Number(String(r).replace(/[^0-9.]+/g,""))};export{r as default};
//# sourceMappingURL=stringToNumber.mjs.map
